<span mat-button mat-dialog-close class="right pointer"><i id="closeOverlay" class="far fa-times-circle"></i></span>
<h1 mat-dialog-title>Set Availability Time {{ availabilityData?.date }}</h1>
<div mat-dialog-content>
  <form class="has-cols" [formGroup]="timeAvailabilityForm">
    <div class="delivery-colle-data-box">
      <fieldset>
        <div class="grid-element-full">
          <div formArrayName="startEndTime">
            <div class="offer-products" *ngFor="let time of timeAvailabilityForm.get('startEndTime').controls; let i = index">
              <div [formGroupName]="i" class="mb-5" style="display: table; width: 100%;">
                <div style="display: table-cell; width: 19px; position: relative;">
                  <i class="far fa-times-circle hvr-grow remove-product" (click)="removeTiming(i)" style="position: absolute; top: 55%;"></i>
                </div>
                <div class="product-q" formGroupName="timings">
                  <div class="porduct-qty">
                    <div class="time-range">
                      <div>
                        <label for="">Start Time</label>
                        <input type="time" formControlName="startTime">
                      </div>
                      <div style="text-align: center;">&nbsp;&nbsp;&nbsp;</div>
                      <div>
                        <label for="">End Time</label>
                        <input type="time" formControlName="endTime">
                      </div>
                    </div>
                  </div>
                </div>
                <br>
              </div>
            </div>
          </div>
          <div class="center" style="width: 100%;">
            <button class="btn mt-0" (click)="$event.preventDefault(); addTiming()">
              Aggiungi Disponibilità<i class="ml-10 fas fa-plus"></i>
            </button>
          </div>
        </div>

        <div class="col-48 grid-element">
          <label for="available"></label>
            <label class="original-label" for="available">
              <input type="checkbox" name="available" formControlName="available" id="available">
              Available
            </label>
        </div>

        <br class="clear">
        <!--
        <div *ngIf="availabilityData?.updateAbleData[0]?.id === undefined">
          <div class="col-48 grid-element">
            <label for="allDaysModel"></label>
              <label class="original-label" for="allDaysModel">
                <input type="checkbox" name="available" id="allDaysModel" [(ngModel)]="allDaysCheck" (change)="checkOnlyOne('allDays')" [ngModelOptions]="{standalone: true}">
                  Tutti i giorni (All Days)
              </label>
          </div>
          <div class="col-48 grid-element">
            <label for="monTofriModel"></label>
              <label class="original-label" for="monTofriModel">
                <input type="checkbox" name="available" id="monTofriModel" [(ngModel)]="monToFriCheck" (change)="checkOnlyOne('monToFri')" [ngModelOptions]="{standalone: true}">
                Da Lunedì a Venerdì (From Monday to Friday)
              </label>
          </div>
          <div class="col-48 grid-element">
            <label for="weekendModel"></label>
              <label class="original-label" for="weekendModel">
                <input type="checkbox" name="available" id="weekendModel" [(ngModel)]="weekendCheck" (change)="checkOnlyOne('weekend')" [ngModelOptions]="{standalone: true}">
                Solo Weekend (Only Weekend Saturday and Sunday)
              </label>
          </div>
          <div class="col-48 grid-element">
            <label for="weeklyModel"></label>
              <label class="original-label" for="weeklyModel">
                <input type="checkbox" name="available" id="weeklyModel" [(ngModel)]="weeklyCheck" (change)="checkOnlyOne('weekly')" [ngModelOptions]="{standalone: true}">
                Ogni settimana (Every Week)
              </label>
          </div>
        </div>
        -->
      </fieldset>
    </div>
  </form>
</div>
<div mat-dialog-actions>
  <div>
    <button mat-button class="btn" (click)=onSubmit()>
      Salva<i class="ml-10 far fa-save"></i>
    </button>
    &nbsp;
    <button mat-button mat-dialog-close class="btn">Chiudi</button>
  </div>
</div>